import clsx from 'clsx';
import Image from 'next/image';

const FeatureIcon = props => {
  const { featureIcon } = props;

  if (!Array.isArray(featureIcon) || featureIcon.length === 0) return null;

  const count = featureIcon.filter(Boolean).length;

  return (
    <ul
      className={clsx(
        'mx-auto mt-5 grid max-w-site grid-cols-2 gap-x-10 gap-y-[34px] px-7 py-10 lg_mt-[60px]  lg_gap-0 lg_px-0 lg_py-5',
        count < 5 ? 'lg_flex lg_flex-wrap lg_justify-center' : 'lg_grid-cols-5',
      )}
    >
      {featureIcon.map(x => {
        if (!x) return null;

        const { label, image } = x;

        return (
          <li
            key={label}
            className={clsx(
              'flex flex-col items-center',
              count < 5 ? 'flex-none lg_basis-[288px]' : '',
              'lg_py-[30px]',
            )}
          >
            <Image
              width={65}
              height={65}
              alt={label}
              src={image}
              quality={100}
              className='h-auto w-[42px] lg_w-[65px]'
            />

            <h2 className='mt-2 font-roboto-medium text-[16px] font-medium lg_mt-2.5 lg_font-roboto-regular lg_text-base lg_font-normal lg_leading-6'>
              {label}
            </h2>
          </li>
        );
      })}
    </ul>
  );
};

export default FeatureIcon;
